<div class="header">
  <div class="title">{{ data?.dialogTitle || (data?.level ? data.level + '次承認者選択' : '承認者選択') }}</div>
</div>
<mat-dialog-content class="dialog-content" autofocus>
  @if (showSpinner) {
    <div class="spinner center">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
  @if (data?.attendanceMode || data?.operationManagerMode) {
    <p class="attendance-scope">同じ組合内のすべての組織・役職から追加できます。企画書の対象条件には限定しません。</p>
    <p class="attendance-hint">
      {{ data?.operationManagerMode ? '現在の担当者も選択済みで表示します。' : '追加済みの人は表示しません。' }}
      人数が多い場合は、役職や氏名で絞り込んでください。
    </p>
  }
  <!-- 検索フォーム -->
  <div class="search-form">
    <!-- 役職 -->
    <div class="form-row">
      <label class="form-label">役職</label>
      <mat-form-field appearance="outline" class="position-select">
        <mat-select aria-label="役職" [placeholder]="data?.attendanceMode || data?.operationManagerMode ? 'すべての役職' : ''" [(ngModel)]="selectedPosition" (selectionChange)="onSearch()">
          <mat-option [value]="null">{{ data?.attendanceMode || data?.operationManagerMode ? 'すべての役職' : '' }}</mat-option>
          @for (pos of officialPositions; track pos.value) {
            <mat-option [value]="pos.value">
              {{ pos.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- 名前 -->
    <div class="form-row">
      <label class="form-label">名前</label>
      <div class="name-inputs">
        <input
          type="text"
          class="name-input"
          [(ngModel)]="lastName"
          placeholder="姓"
          (blur)="onSearch()"
          (keydown.enter)="onEnter($event)"
        />
        <input
          type="text"
          class="name-input"
          [(ngModel)]="firstName"
          placeholder="名"
          (blur)="onSearch()"
          (keydown.enter)="onEnter($event)"
        />
      </div>
    </div>
  </div>
  @if (data?.attendanceMode || data?.operationManagerMode) {
    <button mat-stroked-button class="attendance-search-button" [disabled]="isSearching" (click)="onSearch(true)">検索する</button>
    @if (attendanceSearchError) { <p class="attendance-search-error" role="alert">{{ attendanceSearchError }}</p> }
  }

  <mat-divider></mat-divider>

  <!-- 検索結果 -->
  <div class="search-results">
    <!-- スピナー -->
    @if (isSearching) {
      <div class="results-spinner">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    <!-- 結果一覧 -->
    @if (!isSearching && hasSearched) {
      <div class="results-list">
        @for (approver of searchResults; track $index) {
          <div
            class="result-item"
            [class.selected]="isSelected(approver)"
            (click)="toggleApprover(approver)"
          >
              <mat-checkbox
                class="thin-checkbox"
                [aria-label]="approver.name + 'を選択'"
                [checked]="isSelected(approver)"
                (click)="$event.stopPropagation()"
                (change)="toggleApprover(approver)"
              />
            <div class="approver-details">
              @if(approver.position){
                <div class="approver-name">{{ approver.position }}　{{ approver.name }}</div>
              } @else {
                <div class="approver-name">{{ approver.name }}</div>
              }
              <div class="approver-affiliations">
                @for (affiliation of approver.affiliations; track $index) {
                  <div class="affiliation-row">
                    <div class="dot">・</div>
                    <div>{{ affiliation }}</div>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- 結果なし -->
        @if (searchResults && searchResults.length == 0) {
          <div class="no-results">
            {{ data?.attendanceMode || data?.operationManagerMode ? '該当する対象者が見つかりません。' : '該当する承認者が見つかりません。' }}
          </div>
        }
      </div>
    }
  </div>
}
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions-content">
  <button mat-raised-button (click)="onCancel()">キャンセル</button>
  <button mat-raised-button (click)="onSelect()" class="yes-btn" [disabled]="data?.attendanceMode && !selectedApprovers.length">選択</button>
</mat-dialog-actions>
